export const featuresData = [
  {
    id: 1,
    title: "Automated Trading Bot",
    description:
      "The bot provides traders with real-time automated results that can be trusted.",
    icon: "/icon.svg",
  },
  {
    id: 2,
    title: "Meta Trader 5 Integration",
    description:
      "Our trading bot works with ANY & ALL Meta Trader 5 Trading Brokers.",
    icon: "/integeration-icon.svg",
  },
  {
    id: 3,
    title: "Safe & Secure Trading",
    description:
      "We provide traders a trading opportunity that can be both safe and secure.",
    icon: "/secure-icon.svg",
  },
  {
    id: 4,
    title: "24/7 Trading Capability",
    description:
      "The Forex Miner bot is capable of automatically executing trades throughout the day.",
    icon: "/dollar-icon.svg",
  },
  {
    id: 5,
    title: "24/7 Support Team",
    description:
      "We care about our clients. If you email us, you will get a fast and thoughtful response.",
    icon: "/headphone-icon.svg",
  },
  {
    id: 5,
    title: "Emotionless Trading",
    description:
      "Our bot provides capability of doing emotionless trading without any user intervention.",
    icon: "/integeration-icon.svg",
  },
];
